'use client'

import useModal from '@/hooks/useModal'
import { useSearchParams } from 'next/navigation'
import { useCallback } from 'react'

export type WalletModalTab = 'deposit' | 'withdraw' | 'tip'

export const useWalletModal = () => {
  const searchParams = useSearchParams()
  const { open, update, close, isOpen } = useModal<{
    tab: WalletModalTab
  }>('wallet')

  const onOpen = useCallback(
    (tab: WalletModalTab = 'deposit') => {
      open({ tab })
    },
    [open]
  )

  const onClose = useCallback(() => {
    close()
  }, [close])

  const setTab = useCallback(
    (tab: WalletModalTab) => {
      update({ tab })
    },
    [update]
  )
  const tab = isOpen ? (searchParams.get('tab') as WalletModalTab) : undefined

  return {
    isOpen,
    tab,
    onOpen,
    onClose,
    setTab,
  }
}
